export const isTronAddress = (address: string | undefined): boolean => {
    if (!address) {
        return false
    } else {
        return /^T[A-Za-z1-9]{33}$/.test(address)
    }
}
